import React from "react";
import cn from "classnames";
import requestSupportIcon from "@src/assets/svg/request-remote-access-user-icon.svg";
import {
  AlarmNotificationOPCUAEventContext,
  EventSeverityBand,
} from "@src/types/support";
import { getLanguage } from "@src/cloud-connect/utils/get-language";
import { formatRelativeDateTime } from "@src/cloud-connect/utils/format-relative-date-time";
import styles from "./alarms-notification-card.module.scss";
import { RenderIfUserHasPermission } from "../render-if-user-has-permission/render-if-user-has-permission";

const cssClassName = "alarms-notification-card";

interface AlarmsNotificationCardProps {
  notification: AlarmNotificationOPCUAEventContext;
  severityBand: EventSeverityBand;
  severityIcon: string[];
  idPrefix: string;
  supportText: string;
  onSupportClick: (notification: AlarmNotificationOPCUAEventContext) => void;
}

export const AlarmsNotificationCard = ({
  notification,
  severityBand,
  severityIcon,
  idPrefix,
  supportText,
  onSupportClick,
}: AlarmsNotificationCardProps) => {
  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__header`]}>
        <div className={styles[`${cssClassName}__title-row`]}>
          {(severityBand === "urgent" || severityBand === "warning") && (
            <img
              src={severityIcon[0]}
              alt=""
              className={styles[`${cssClassName}__severity-icon`]}
            />
          )}
          {/* TODO: Uncomment the code below to show the title with severity. */}
          {/* <div className={styles[`${cssClassName}__title-wrap`]}>
            <img
              src={severityIcon[1] ?? severityIcon[0]}
              alt=""
              className={styles[`${cssClassName}__title-icon`]}
            />
            <h3
              className={cn(
                styles[`${cssClassName}__title`],
                styles[`${cssClassName}__title--${severityBand}`],
              )}
            >
              {notification.data_source_name &&
                `[${notification.data_source_name}] `}
              {notification.event_type}
            </h3>
          </div> */}
        </div>
        <span className={styles[`${cssClassName}__date`]}>
          {formatRelativeDateTime(notification.occured_at, getLanguage())}
        </span>
      </div>

      <p
        className={cn(styles[`${cssClassName}__description`], {
          [styles[`${cssClassName}__description--urgent`]]:
            severityBand === "urgent",
        })}
      >
        {notification.message}
      </p>

      <div className={styles[`${cssClassName}__footer`]}>
        <span className={styles[`${cssClassName}__id`]}>
          <p className={styles[`${cssClassName}__id-prefix`]}>{idPrefix}</p>
          {notification.event_id}
        </span>
        <RenderIfUserHasPermission permission="create-tickets">
          <button
            className={styles[`${cssClassName}__support-btn`]}
            type="button"
            onClick={() => onSupportClick(notification)}
          >
            <img
              src={requestSupportIcon}
              alt=""
              className={styles[`${cssClassName}__support-btn-icon`]}
            />
            <span>{supportText}</span>
          </button>
        </RenderIfUserHasPermission>
      </div>
    </div>
  );
};
